export default function FilterBar({
    search,
    setSearch,
    sort,
    setSort,
    setPage,
}) {
    return (
        <div className="bg-white rounded-xl shadow p-4 flex flex-col md:flex-row gap-4 justify-between">

            <input
                value={search}
                onChange={(e) => {
                    setSearch(e.target.value);
                    setPage(1);
                }}
                placeholder="Search..."
                className="border rounded-lg px-4 py-2 md:w-80"
            />

            <select
                value={sort}
                onChange={(e) => {
                    setSort(e.target.value);
                    setPage(1);
                }}
                className="border rounded-lg px-4 py-2"
            >
                <option value="latest">Latest</option>
                <option value="oldest">Oldest</option>
                <option value="high">High Amount</option>
                <option value="low">Low Amount</option>
            </select>

        </div>
    );
}